import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Report from './Report'

const StyledDiv = styled.div`
  transition: margin 0.5s;
  display: flex;
  height: 100%;
  z-index: 0;
  align-items: stretch;
  margin-left: ${({ leftDocked, baseLeftMargin }) => (leftDocked ? '300' : baseLeftMargin)}px;
  margin-right: ${({ rightDocked, baseRightMargin }) => (rightDocked ? '300' : baseRightMargin)}px;
`

class ReportWindow extends React.Component {
  render() {
    const { leftSidebar, rightSidebar, leftDocked, rightDocked, url, tracker } = this.props
    const baseLeftMargin = leftSidebar ? '30' : '0'
    const baseRightMargin = rightSidebar ? '30' : '0'
    return (
      <StyledDiv
        leftDocked={leftDocked}
        rightDocked={rightDocked}
        baseLeftMargin={baseLeftMargin}
        baseRightMargin={baseRightMargin}
      >
        {url && <Report key={url} url={url} tracker={tracker ? () => tracker(url) : null} />}
      </StyledDiv>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    leftDocked: state.dataDirectory.docked,
    rightDocked: state.contextPane.docked,
    ...ownProps,
  }
}

export default connect(mapStateToProps)(ReportWindow)
